import { createHttpService } from "@nebulajs/http";
import { NMessage } from "@nebulajs/web";
import access from "./access";
import router from "./router";

export default createHttpService({
  options: {
    baseURL: `${import.meta.env.ENV_EMAS_HTTP_API}/${import.meta.env.ENV_MODE}`,
  },
  interceptor: {
    onRequestFulfilled: (config) => {
      if (!config.headers) {
        config.headers = {};
      }
      config.headers.Authorization = access.token;
      return config;
    },
    onRequestRejected: (error) => {
      console.log(error);

      return Promise.resolve({
        result: false,
        status: "fail",
        code: -1,
        msg: "服务器稍后重试",
        data: error,
      });
    },
    onResponseFulfilled: ({ data }) => {
      if (data.success === false && data.error) {
        return {
          result: false,
          status: "fail",
          code: data.error.code,
          msg: data.error.message,
          data: null,
        };
      }
      return {
        result: data.status === "success",
        status: data.status,
        code: data.code,
        msg: data.msg,
        data: data.data,
      };
    },
    onResponseRejected: (error) => {
      return Promise.resolve({
        result: false,
        status: "fail",
        code: error.response ? error.response.status : -1,
        msg: "服务器稍后重试",
        data: error,
      });
    },
  },
  success: ({ request, response }) => {
    if (request.message !== true || !response.msg) return;
    NMessage.success({ content: response.msg });
  },
  error: ({ request, response }) => {
    if (response.code === 2000) {
      return router.push("/account/login");
    }
    if (request.message === false || !response.msg) return;
    NMessage.error({ content: response.msg });
  },
});
